export const bankDeposit = {
  depositInstructions: "Deposito-instruksies",
  depositInstructionsMessageVzla:
    "Registreer jou mobiele betaling vir outomatiese BDV-betalings. As jy reeds betaal het sonder om te registreer, gebruik hierdie vorm.",
  depositInstructionsMessagePlaza:
    "Geagte gebruiker, om jou mobiele betaling te valideer en na jou virtuele beursie te krediteer, moet dit met dieselfde ID en foonnommer gemaak word wat jy gebruik het om jou rekening te registreer. As jy 'n ander foonnommer met dieselfde ID geassosieer het, voeg dit eenvoudig by jou mobiele betaalrekeninge sodat die betaling gekrediteer kan word.",
  depositInstructionsImportantMessage: "BELANGRIK: Die saldo sal opgedateer word wanneer jy voortgaan klik",
  depositInstructionsBank: "Bank",
  depositInstructionsMobilePhone: "Foon",
  depositInstructionsContinue: "Gaan voort",
  depositInstructionsBack: "Terug",
  depositInstructionsCancel: "Kanselleer",
  depositInstructionsCopy: "Kopieer",
  depositInstructionsCopied: "Gekopieer",
  depositInstructionsError: "Daar was 'n fout:",
  depositInstructionsOptions: "Hoe wil jy deponeer?",
  depositInstructionsBankTitle: "Sukses!",
  depositInstructionsBankSuccess: "Deposito suksesvol gekonsolideer!",
  depositInstructionsBankWarning: "Let op!",
  depositInstructionsBankError: "Geen transaksie gevind nie",

  depositInstructionsBankOptionsTitle: "Kies jou bank",
  depositInstructionsBankOptions: "Kies 'n bank",
  depositInstructionsBankVzlaSelectDate: "Kies datum",
  depositInstructionsCreditSoon: "Jou deposito sal binne 'n paar oomblikke gekrediteer word",
  depositInstructionsPaymentDone: "Ek het reeds my betaling gemaak",

  depositInstructionsCancelBtn: "Kanselleer",
  depositInstructionsCopyBtnTitle: "Druk die knoppie om te kopieer",

  // VENEZUELA-BANK
  depositInstructionsBankVzlaReference: "Verwysing",
  depositInstructionsBankVzlaAmount: "Bedrag",
  depositInstructionsBankVzlaDate: "Datum",
  depositInstructionsBankVzlaBank: "Bank",
  depositInstructionsBankVzlaBankOptions: "Kies 'n bank",
  depositInstructionsBankVzlaForm: "Vorm",
  depositInstructionsBankVzlaFormTitle: "Betalingsregistrasievorm",
  depositInstructionsBankVzlaFormInfo: "Gebruik die vorm as jy reeds betaal het.",
  depositInstructionsBankVzlaSupportMessage: "Is jou betaling nie outomaties gekrediteer nie?",
  depositInstructionsBankVzlaSupportLink: "Kontak ons 24/7-ondersteuning",

  //ZELLE
  depositInstructionsZelleMessage:
    "Om met Zelle te deponeer, stuur jou betaling na zelle@randrush.com en stuur ons 'n boodskap op WhatsApp met die kwitansie. Ons sal dit vinnig verwerk.",
  depositInstructionsZelleEmail: "E-pos",
  depositInstructionsZelleCopyBtnTitle: "Tik die knoppie om die e-pos te kopieer",
  depositInstructionsSupport: "Kontak ondersteuning",

  //BINANCE
  depositInstructionsBinanceTitle: "Binance USDT-deposito",
  depositInstructionsBinanceAmount: "Bedrag",
  depositInstructionsBinanceMinAmount: "Minimum deposito",
  depositInstructionsBinanceCompletePayment: "Voltooi jou Binance-betaling",
  depositInstructionsBinanceOptions: "Kies jou voorkeurbetaalmetode hieronder",
  depositInstructionsBinanceOptionsTitle: "Betaalmetodes",
  depositInstructionsBinanceUseQR: "Skandeer hierdie QR-kode met jou Binance-toep",
  depositInstructionsBinanceLink: "Klik om die betaalbladsy in Binance oop te maak",
  depositInstructionsBinanceOpenLink: "Maak Binance-betaalskakel oop",
  depositInstructionsBinanceStatus: "Transaksiestatus",
  depositInstructionsBinanceContinue: "Gaan voort",
  depositInstructionsBinanceBack: "Terug",
  depositInstructionsBinanceCheckingStatus: "Kontroleer status...",
  depositInstructionsBinancePending: "hangende",
  depositInstructionsBinanceEnterAmount: "Voer bedrag in om te deponeer",
  depositInstructionsBinanceGeneratedLink: "Betaalskakel gegenereer! Kies jou voorkeurbetaalmetode.",
  depositInstructionsBinanceError: "Kon nie deposito skep nie. Probeer asseblief weer.",
  depositInstructionsBinanceValidAmount: "Voer asseblief 'n geldige bedrag in",
  depositInstructionsBinancePaymentCompleted: "Betaling suksesvol voltooi!",
  depositInstructionsBinanceScanQR: "Skandeer QR-kode",
  depositInstructionsBinancePaymentLinkTitle: "Betaalskakel",
  depositInstructionsBinanceOrSeparator: "of",

  //PAYKU
  depositInstructionsPaykuTitle: "Payku CLP-deposito",
  depositInstructionsPaykuDescription: "Maak deposito's in Chileense pesos met verskeie betaalmetodes",
  depositInstructionsPaykuAmount: "Bedrag",
  depositInstructionsPaykuEmail: "E-pos",
  depositInstructionsPaykuPaymentMethod: "Betaalmetode",
  depositInstructionsPaykuMinAmount: "Minimum deposito: 1 000 CLP",
  depositInstructionsPaykuEnterAmount: "Voer bedrag in om te deponeer",
  depositInstructionsPaykuEmailPlaceholder: "jou@email.com",
  depositInstructionsPaykuSelectMethod: "Kies betaalmetode",
  depositInstructionsPaykuCreatePayment: "Skep betaling",
  depositInstructionsPaykuCompletePayment: "Voltooi jou Payku-betaling",
  depositInstructionsPaykuOptions: "Voltooi jou betaling in die oopgemaakte venster.",
  depositInstructionsPaykuOpenLink: "Maak betaalskakel oop",
  depositInstructionsPaykuStatus: "Betalingstatus",
  depositInstructionsPaykuCheckingStatus: "Kontroleer status...",
  depositInstructionsPaykuPending: "Hangende",
  depositInstructionsPaykuapproved: "Goedgekeur",
  depositInstructionsPaykucompleted: "Voltooi",
  depositInstructionsPaykurejected: "Verwerp",
  depositInstructionsPaykuexpired: "Verval",
  depositInstructionsPaykuInstructions: "Jy sal teruggelei word sodra die betaling verwerk is.",
  depositInstructionsPaykuError: "Kon nie betaling skep nie. Probeer asseblief weer.",
  depositInstructionsPaykuValidEmail: "Voer asseblief 'n geldige e-posadres in",
  depositInstructionsPaykuPaymentCompleted: "Betaling suksesvol voltooi!",
  depositInstructionsPaykuPaymentRejected: "Betaling is verwerp",
  depositInstructionsPaykuPaymentExpired: "Betaling het verval",
  depositInstructionsPaykuUnsupportedCurrency: "Geldeenheid word nie ondersteun nie",
  depositInstructionsPaykuOnlyCLP: "Payku is slegs beskikbaar vir Chileense pesos (CLP)",
  depositInstructionsPaykuAllMethods: "Alle metodes",
  depositInstructionsPaykuAllMethodsDescription: "Aanbeveel - Alle beskikbare metodes",
  depositInstructionsPaykuWebpayDescription: "Mees algemene betaalmetode",
  depositInstructionsPaykuWebpayPlus1_3: "Webpay plus (1-3 paaiemente)",
  depositInstructionsPaykuWebpayPlus4_6: "Webpay plus (4-6 paaiemente)",
  depositInstructionsPaykuWebpayPlus7_12: "Webpay plus (7-12 paaiemente)",
  depositInstructionsPaykuWebpayPlusDesc: "Kredietopsie",

  // PAYKU-ONTREKKING
  withdrawalPaykuTitle: "Payku CLP-onttrekking",
  withdrawalPaykuAvailableBalance: "Beskikbare saldo",
  withdrawalPaykuAmount: "Bedrag",
  withdrawalPaykuBeneficiaryName: "Begunstigdenaam",
  withdrawalPaykuEmail: "E-pos",
  withdrawalPaykuPhone: "Foon",
  withdrawalPaykuRUT: "Chileense RUT",
  withdrawalPaykuBank: "Bank",
  withdrawalPaykuAccountType: "Rekeningtipe",
  withdrawalPaykuAccountNumber: "Rekeningnommer",
  withdrawalPaykuMinAmount: "Minimum onttrekking: 5 000 CLP",
  withdrawalPaykuSuccessTitle: "Onttrekkingsversoek ingedien!",
  withdrawalPaykuSuccessMessage:
    "Jou onttrekkingsversoek is suksesvol geskep. Die fondse sal binne die volgende paar uur na jou bankrekening verwerk word.",
  withdrawalPaykuSuccessAmountLabel: "Versoekte bedrag",
  withdrawalPaykuSuccessBankLabel: "Bestemmingsbank",
  withdrawalPaykuSuccessClose: "Verstaan",
  withdrawalPaykuEnterAmount: "Voer bedrag in om te onttrek",
  withdrawalPaykuBeneficiaryNamePlaceholder: "Volle naam van rekenaarhouer",
  withdrawalPaykuEmailPlaceholder: "jou@email.com",
  withdrawalPaykuPhonePlaceholder: "+56912345678",
  withdrawalPaykuRUTPlaceholder: "12345678-9",
  withdrawalPaykuRUTFormat: "Formaat: 12345678-9",
  withdrawalPaykuSelectBank: "Kies bank",
  withdrawalPaykuAccountNumberPlaceholder: "Rekeningnommer",
  withdrawalPaykuSubmit: "Dien onttrekking in",
  withdrawalPaykuSuccess: "Onttrekkingsversoek suksesvol ingedien!",
  withdrawalPaykuError: "Kon nie onttrekking indien nie. Probeer asseblief weer.",
  withdrawalPaykuInsufficientBalance: "Onvoldoende saldo",
  withdrawalPaykuBeneficiaryNameRequired: "Begunstigdenaam word vereis",
  withdrawalPaykuValidEmail: "Voer asseblief 'n geldige e-posadres in",
  withdrawalPaykuPhoneRequired: "Foonnommer word vereis",
  withdrawalPaykuValidRUT: "Voer asseblief 'n geldige Chileense RUT in (formaat: 12345678-9)",
  withdrawalPaykuBankRequired: "Kies asseblief 'n bank",
  withdrawalPaykuAccountNumberRequired: "Rekeningnommer word vereis",
  withdrawalPaykuUnsupportedCurrency: "Geldeenheid word nie ondersteun nie",
  withdrawalPaykuRegisterRUTTitle: "Registreer jou Chileense RUT",
  withdrawalPaykuRegisterRUTDescription:
    "Om via Payku te onttrek benodig ons jou RUT. Dit kan slegs een keer geregistreer word en elke toekomstige onttrekking sal hierdie selfde RUT gebruik.",
  withdrawalPaykuRegisterRUTSubmit: "Registreer RUT",
  withdrawalPaykuRegisterRUTWarning:
    "Belangrik: Sodra dit geregistreer is, kan hierdie RUT nie verander word nie en jy sal slegs na bankrekeninge wat daaraan gekoppel is kan onttrek.",
  withdrawalPaykuRUTRegistrationWarning: "Jy kan jou RUT slegs een keer registreer. Maak seker dit is korrek.",
  withdrawalPaykuRUTRegistrationError: "Kon nie die RUT registreer nie. Probeer asseblief weer.",
  withdrawalPaykuRUTLockedHint: "Onttrekkings word slegs toegelaat na bankrekeninge wat aan hierdie RUT gekoppel is.",
  withdrawalPaykuCreateAccountTitle: "Voeg Chileense bankrekening by",
  withdrawalPaykuCreateAccountSubmit: "Stoor rekening",
  withdrawalPaykuBankAccountRequiredFields: "Bank, rekeningnommer en rekenaarhouernaam word vereis.",
  withdrawalPaykuBankAccountCreateError: "Kon nie die bankrekening skep nie. Probeer asseblief weer.",
  withdrawalPaykuSelectAccount: "Kies 'n bankrekening",
  withdrawalPaykuSelectAccountRequired: "Jy moet 'n bankrekening kies.",
  withdrawalPaykuAddNewAccount: "Voeg nuwe rekening by",
  withdrawalPaykuDeleteAccount: "Verwyder rekening",
  withdrawalPaykuOnlyCLP: "Payku-onttrekkings is slegs beskikbaar vir Chileense pesos (CLP)",

  // PAYKU-TERUGROEPBLADSY
  paykuCallbackVerifying: "Verifieer betaling",
  paykuCallbackVerifyingMessage: "Wag asseblief terwyl ons jou transaksiestatus verifieer...",
  paykuCallbackSuccess: "Betaling suksesvol!",
  paykuCallbackSuccessMessage: "Jou deposito is suksesvol verwerk. Die saldo is na jou rekening gekrediteer.",
  paykuCallbackFailed: "Betaling het misluk",
  paykuCallbackFailedMessage:
    "Jammer, jou betaling kon nie verwerk word nie. Probeer asseblief weer of kontak ondersteuning.",
  paykuCallbackPending: "Betaling hangende",
  paykuCallbackPendingMessage: "Jou betaling word verwerk. Jy sal 'n kennisgewing ontvang wanneer dit voltooi is.",
  paykuCallbackOrderId: "Bestelling-ID",
  paykuCallbackAmount: "Bedrag",
  paykuCallbackRedirectMessage: "Jy sal oor {{seconds}} sekondes na die tuisblad herlei word...",
  paykuCallbackGoHome: "Gaan na tuisblad",

  // Ubii pago-wesies-eis
  depositListRif: "RIF",
  ubiiPagoClaimTitle: "Ubii Pago-deposito",
  ubiiPagoClaimBanksHint: "Betaal uit die Ubii-toep met jou voorafbetaalde saldo.",
  ubiiPagoClaimStepsTitle: "Betaal met die Ubii-toep",
  ubiiPagoClaimStep1: "Kies 'n bank hieronder en kopieer die ontvangerbesonderhede (belasting-ID, bank en foon).",
  ubiiPagoClaimStep2: "Maak die Ubii-toep oop, teken in en kies Oordrag of Mobiele Betaling.",
  ubiiPagoClaimStep3: "Voer in die Ubii-toep die besonderhede in wat jy gekopieer het en bevestig die oordrag.",
  ubiiPagoClaimStep4: "Let op die bedrag en die laaste 6 syfers van jou verwysingsnommer.",
  ubiiPagoClaimStep5: "Tik die “Ek het reeds gedeponeer”-knoppie.",
  ubiiPagoClaimPaidCta: "Ek het reeds gedeponeer",
  ubiiPagoClaimBack: "Terug",
  ubiiPagoClaimReportTitle: "Rapporteer betaling",
  ubiiPagoClaimReportHint: "Voer die bedrag in en slegs die laaste 6 syfers van die verwysing van jou kwitansie.",
  ubiiPagoClaimAmountLabel: "Bedrag",
  ubiiPagoClaimAmountInvalid: "Voer 'n geldige bedrag groter as 0 in.",
  ubiiPagoClaimAmountDecimalHint: "Jy kan 'n komma of 'n punt gebruik; dit word met 'n komma vertoon (bv. 100,50).",
  ubiiPagoClaimReferenceLabel: "Laaste 6 syfers van die verwysing",
  ubiiPagoClaimReferencePlaceholder: "123456",
  ubiiPagoClaimReferenceHint: "Moenie die volledige verwysing invoer nie: slegs die laaste 6 syfers van jou kwitansie.",
  ubiiPagoClaimReferenceInvalid: "Voer presies die laaste 6 syfers van die verwysing in.",
  ubiiPagoClaimSubmit: "Rapporteer betaling",
  ubiiPagoClaimClose: "Sluit",
  ubiiPagoClaimAttemptsInfo: "Maksimum {{max}} pogings. As jy opraak, wag 10 minute.",
  ubiiPagoClaimAttemptsCount: "Pogings: {{current}}/{{max}}",
  ubiiPagoClaimCooldownHint: "Jy kan weer probeer wanneer die aftelling eindig.",
  ubiiPagoClaimSuccessToast: "Deposito gekrediteer",
  ubiiPagoClaimSuccessTitle: "Deposito gekrediteer",
  ubiiPagoClaimSuccessMessage: "Jou saldo is gereed om te speel.",
  ubiiPagoClaimNewBalanceLabel: "Nuwe saldo",
  ubiiPagoClaimErrorInvalid: "Voer asseblief 'n geldige bedrag en verwysingsnommer in.",
  ubiiPagoClaimErrorNotFound:
    "Ons kon nie 'n ooreenstemmende betaling vind nie. Kontroleer die bedrag en verwysingsnommer, of wag 'n paar minute as jy dit pas gestuur het en probeer weer.",
  ubiiPagoClaimErrorManualReview:
    "Dit benodig handmatige hersiening. Kontak asseblief ondersteuning met jou betalingsverwysing.",
  ubiiPagoClaimErrorRateLimit: "Jy het die limiet van 10 pogings bereik. Wag 10 minute en probeer weer.",
  ubiiPagoClaimErrorGeneric:
    "Iets het verkeerd geloop. Probeer asseblief oor 'n oomblik weer, of kontak ondersteuning.",
};
